import React from "react";

import ButtonWithIcon from "./ButtonWithIcon";

const ButtonSignIn = function (props) {
  return (
    <ButtonWithIcon
      className={props.className}
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          />
        </svg>
      }
      disabled={props.disabled}
      onClick={props.onClick}
    >
      Sign in
    </ButtonWithIcon>
  );
};

export default ButtonSignIn;
